"use client";

import { IcArrowRight } from "@jetblue/kit-icons/ic-arrow-right";

import type { InfoCookiePreferencesButtonDialog } from "../../../dialogs/info/manage-cookie-preferences";

export const InfoCookiePreferencesButton = ({
  label,
}: InfoCookiePreferencesButtonDialog) => (
  <div
    className="
      container mx-auto

      [*+&]:mt-4

      md:[*+&]:mt-6
    "
  >
    <button
      aria-haspopup="dialog"
      className="
        inline cursor-pointer items-center p-2.5 text-start text-label font-bold
        text-foreground-primary focus-outline

        group-data-[has-dark-theme=true]/theme:text-foreground-on-primary
        group-data-[has-dark-theme=true]/theme:outline-border-variant-lowest

        hover:underline
      "
      data-fs-element="cookie-preferences-button"
      onClick={() => {
        const openTrustArcConsentModal = (
          globalThis as unknown as {
            truste?: { eu?: { clickListener?: () => void } };
          }
        ).truste?.eu?.clickListener;

        if (openTrustArcConsentModal) {
          openTrustArcConsentModal();
        }
      }}
    >
      <span className="inline">{label}</span>

      <span className="ms-2">
        <IcArrowRight aria-hidden className="inline align-middle" />
      </span>
    </button>
  </div>
);
